import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { LinkGroupsComponent } from './link-groups/link-groups.component';

@Component({
  selector: 'tab-groups',
  templateUrl: './tab-groups.component.html',
  styleUrls: ['./tab-groups.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TabGroupComponent {
  @Input() public linkedGroups: FormArray;
  @Input() public isViewMode: boolean;
  public searchInput: FormControl;

  constructor(private matDialog: MatDialog) {
    this.searchInput = new FormControl();
  }

  public linkGroups(): void {
    const linkGroupsDialog = this.matDialog.open(LinkGroupsComponent, {
      panelClass: ['dialog-users'],
      data: this.linkedGroups.value
    });

    linkGroupsDialog.afterClosed().subscribe((groupsControl) => {
      if (groupsControl && groupsControl.length) {
        for (const groupControl of groupsControl) {
          this.linkedGroups.setControl(this.linkedGroups.value.length, groupControl);
        }
      }
    });
  }
}
